import {
  Button,
  Card,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Skeleton,
  Stack,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { BIBlue } from "../../assets/helpers";
import { useSelector } from "react-redux";
import { FETCH_USER_PRODUCTS } from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";
import Addproducts from "./Addproducts";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";
import { English } from "../../constant/EnglishFallback";
import Loader from "../../common/Loader";
import EducationSekeleton from "./EducationSkeleton";
import InfiniteScroll from "react-infinite-scroll-component";

export default function Products({
  profileLoading,
  profileSectionLoadingState,
  setProfileSectionLoadingState
}) {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);
  const [showProducts, setShowproducts] = useState(false);
  const [selectedProducts, setSelectedproducts] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const { userId } = useParams();
  const isFormUserDashboard = loginData?.userInformation?.UserId == userId ? true : false;
  const navigate = useNavigate();

  const {
    BUTTON_EDIT = English?.Profile?.BUTTON_EDIT,
    TEXT_PRODUCTS_IN_PROFILE = English?.Profile?.TEXT_PRODUCTS_IN_PROFILE,
    TEXT_ADD_MY_PRODUCTS = English?.Profile?.TEXT_ADD_MY_PRODUCTS,
    TEXT_DESC_PRODUCT_PROFILE = English?.Profile?.TEXT_DESC_PRODUCT_PROFILE
  } = multiLanguageData?.Profile || {};

  useEffect(() => {
    getProducts(1);
  }, [userId]);

  const increaseOffset = (callback) => {
    setPageNumber((prevPageNr) => prevPageNr + 1);
    callback(pageNumber + 1);
  };

  const getProducts = async (pageNr) => {
    try {
      setAllDataLoaded(true);
      if (pageNr === 1) {
        setProfileSectionLoadingState((prev) => ({
          ...prev,
          productLoader: true
        }));
      }
      const getObject = {
        PageNr: pageNr || 1,
        FullSearch: "",
        NrOfRecPerPage: 10,
        IncludeRecordNr: "true",
        TypeOfObjectReturned: "",
        UserId: userId,
        SearchList: [{ UserId: userId }],
        FetchAllowedRecordsOnly: true
      };
      let getResponse = await Postrequestcall(
        FETCH_USER_PRODUCTS,
        getObject,
        loginData?.accessToken
      );
      if (getResponse?.status === 200) {
        let getList = getResponse?.data?.data?.sort((a, b) => {
          if (a.endDate === "" || a.endDate === null) a.endDate = moment();
          if (b.endDate === "" || b.endDate === null) b.endDate = moment();
          let dateA = new Date(a.endDate),
            dateB = new Date(b.endDate);
          return dateB - dateA;
        });
        getList = getList.map((item) => {
          return {
            ...item,
            selected: true
          };
        });
        if (pageNr === 1) {
          setSelectedproducts(getList);
        } else {
          setSelectedproducts([...selectedProducts, ...getList]);
        }
      }
    } catch (error) {
      console.log("getProducts-> Error While Fetching User Product: ", error);
    } finally {
      setAllDataLoaded(false);
      setProfileSectionLoadingState((prev) => ({
        ...prev,
        productLoader: false
      }));
    }
  };

  const getProductDescriptionText = (item) => {
    if (item.productType && item.manufacturerName) {
      return `${item.productType} | ${item.manufacturerName}`;
    } else if (item.productType) {
      return `${item.productType} `;
    } else if (item.manufacturerName) {
      return `${item.manufacturerName} `;
    } else {
      return "Unknown";
    }
  };

  const addEditproducts = () => {
    setShowproducts(!showProducts);
  };

  if (profileSectionLoadingState?.productLoader) {
    return <EducationSekeleton />;
  }

  return !isFormUserDashboard && selectedProducts?.length === 0 ? null : (
    <>
      <Card
        className="pagelist-content"
        sx={{
          height: selectedProducts?.length === 0 ? "120px" : "",
          maxHeight: !profileLoading?.isProductLoading ? "45vh" : "",
          overflow: "scroll",
          scrollbarWidth: "none"
        }}>
        <Stack
          direction="column"
           sx={{ gap: "8px",
            padding: "10px",
            position: "sticky",
            top: "0px",
            background: "white",
            width: "auto",
            zIndex: "1"
          }}>
          <Stack sx={{ pb: 1,  justifyContent: "space-between", alignItems: "center" }} direction={"row"}>
            <Typography variant="h6">{TEXT_PRODUCTS_IN_PROFILE}</Typography>
            {!isFormUserDashboard ? null : (
              <Button
                variant="contained"
                sx={{ width: "fit-content", backgroundColor: BIBlue }}
                className="active-btn"
                onClick={() => addEditproducts()}>
                {selectedProducts?.length > 0 ? BUTTON_EDIT : TEXT_ADD_MY_PRODUCTS}
              </Button>
            )}
          </Stack>
          {!isFormUserDashboard ? null : (
            <>
              {selectedProducts?.length == 0 ? (
                <Typography>{TEXT_DESC_PRODUCT_PROFILE}</Typography>
              ) : null}
            </>
          )}
        </Stack>
        <InfiniteScroll
          dataLength={selectedProducts?.length}
          next={async () => {
            increaseOffset((pageNr) => {
              getProducts(pageNr);
            });
          }}
          hasMore={true}
          loader={
            !allDataLoaded ? null : (
              <Stack sx={{ gap: 1 }} direction="column" m={1} >
                <Skeleton variant="rectangular" height={36} />
                <Skeleton variant="rectangular" height={36} />
              </Stack>
            )
          }
          height={selectedProducts?.length < 8 ? "24vh" : "42vh"}
          style={{ overflow: "scroll" }}>
          <List disablePadding>
            <Stack spacing={1} sx={{ margin: 1 }}>
              {selectedProducts?.map((item, index) => (
                <Card
                  key={index} // Using index as a fallback key
                  className="pagelist-content">
                  <ListItem sx={{ m: 0 }} key={index.toString()} disablePadding>
                    <ListItemButton
                      sx={{ display: "flex", flexDirection: "row" }}
                      onClick={() => {
                        navigate(`/product/${item?.productId}`);
                      }}>
                      <ListItemText
                        sx={{ m: 0 }}
                        primary={item?.productName}
                        secondary={getProductDescriptionText(item)}
                      />
                    </ListItemButton>
                  </ListItem>
                </Card>
              ))}
            </Stack>
          </List>
        </InfiniteScroll>
      </Card>

      {showProducts && (
        <Addproducts
          getProducts={getProducts}
          setSelectedproducts={setSelectedproducts}
          selectedProducts={selectedProducts}
          showProducts={showProducts}
          setShowproducts={setShowproducts}
          handleClose={() => setShowproducts(false)}
        />
      )}
    </>
  );
}

